const translations = {
  page_title: 'Analytics',

  source_placeholder: 'Source',
  period_placeholder: 'Period',
  since_placeholder: 'Since',
  until_placeholder: 'Until',
  sort_placeholder: 'Sort by',
  filter_placeholder: 'Filter by',
  show_placeholder: 'Show by',

  print_report: 'Print report',

  total_traffic: 'Traffic',
  total_shares: 'Shares - AutoComparte',
  traffic_by_period: 'Traffic by period',
  traffic_by_device: 'Traffic by device',

  pages: 'Pages',
  sources: 'Sources',

  all: 'All domains',
  this_month: 'This month',
  this_week: 'This week',
  custom: 'Custom',
  views: 'Views',
  site: 'Site',
  user: 'User',
  domain: 'Domain',
  count: 'Count',
  page: 'Page',
  source: 'Source',

  impressions: 'Impressions',
  featured: 'Featured',
  inventory: 'Inventory',

  convertions: 'Convertions',
  interaction: 'Interaction',
  total: 'Total',
  convertions_by_period: 'Convertions by period',
  convertions_by_device: 'Convertions by device',

  vehicles_performance: 'Vehicles performance',
  vehicle: 'Vehicle',
  vin: 'VIN',

  more_views: 'More views',
  less_views: 'Less views',
  more_impressions: 'More impresions',
  more_total: 'More total',
  total_views: 'Total views',
  total_impressions: 'Total impressions',
  total_featured: 'Total featured',
  total_convertions: 'Total convertions',

  distribution_by_device: 'Distribution by device',
  view_more: 'View more',
};

export default translations;
